/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/audit/audit-filter/audit-filter.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../node_modules/@angular/forms/src/directives/select_control_value_accessor.ngfactory';
import * as import10 from '../../../../../node_modules/@angular/forms/src/directives/select_multiple_control_value_accessor.ngfactory';
import * as import11 from '@angular/core/src/linker/view_container';
import * as import12 from '@angular/core/src/linker/element_ref';
import * as import13 from '@angular/forms/src/directives/select_control_value_accessor';
import * as import14 from '@angular/forms/src/directives/select_multiple_control_value_accessor';
import * as import15 from '../../../../../../public/upgrade/core/datepicker/datepicker-range.component';
import * as import16 from '../../../core/datepicker/datepicker-range.component.ngfactory';
import * as import17 from '../../../../../node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import18 from '../../../../../node_modules/@angular/forms/src/directives/number_value_accessor.ngfactory';
import * as import19 from '../../../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import20 from '../../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import21 from '../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import22 from '@ngx-translate/core/src/translate.pipe';
import * as import23 from '../../../../../../public/upgrade/core/datepicker/calendar-config';
import * as import24 from '@angular/core/src/linker/template_ref';
import * as import25 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import26 from '@ngx-translate/core/src/translate.service';
import * as import27 from '@angular/forms/src/directives/default_value_accessor';
import * as import28 from '@angular/forms/src/directives/number_value_accessor';
import * as import29 from '@angular/forms/src/directives/control_value_accessor';
import * as import30 from '@angular/forms/src/directives/ng_model';
import * as import31 from '@angular/forms/src/directives/ng_control';
import * as import32 from '@angular/forms/src/directives/ng_control_status';
import * as import33 from '@angular/common/src/directives/ng_for';
export class Wrapper_AuditFilterComponent {
  /*private*/ _eventHandler:Function;
  context:import0.AuditFilterComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  subscription0:any;
  subscription1:any;
  constructor() {
    this._changed = false;
    this.context = new import0.AuditFilterComponent();
    this._expr_0 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
    (this.subscription1 && this.subscription1.unsubscribe());
  }
  check_actions(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.actions = currValue;
      this._expr_0 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean,emit1:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.filter.subscribe(_eventHandler.bind(view,'filter'))); }
    if (emit1) { (this.subscription1 = this.context.export.subscribe(_eventHandler.bind(view,'export'))); }
  }
}
var renderType_AuditFilterComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_AuditFilterComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.AuditFilterComponent>;
  _AuditFilterComponent_0_3:Wrapper_AuditFilterComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_AuditFilterComponent_Host0,renderType_AuditFilterComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'audit-filter',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_AuditFilterComponent0(this.viewUtils,this,0,this._el_0);
    this._AuditFilterComponent_0_3 = new Wrapper_AuditFilterComponent();
    this.compView_0.create(this._AuditFilterComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._AuditFilterComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.AuditFilterComponent) && (0 === requestNodeIndex))) { return this._AuditFilterComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._AuditFilterComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._AuditFilterComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const AuditFilterComponentNgFactory:import8.ComponentFactory<import0.AuditFilterComponent> = new import8.ComponentFactory<import0.AuditFilterComponent>('audit-filter',View_AuditFilterComponent_Host0,import0.AuditFilterComponent);
const styles_AuditFilterComponent:any[] = ([] as any[]);
class View_AuditFilterComponent1 extends import2.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import9.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import10.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import11.ViewContainer) {
    super(View_AuditFilterComponent1,renderType_AuditFilterComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_4 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'option',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSelectOption_0_3 = new import9.Wrapper_NgSelectOption(new import12.ElementRef(this._el_0),this.renderer,(<View_AuditFilterComponent0>this.parentView)._SelectControlValueAccessor_29_3.context);
    this._NgSelectMultipleOption_0_4 = new import10.Wrapper_NgSelectMultipleOption(new import12.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import13.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import14.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.context.$implicit;
    this._NgSelectOption_0_3.check_ngValue(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.context.$implicit;
    this._NgSelectMultipleOption_0_4.check_ngValue(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_4:any = import3.inlineInterpolate(1,'',this.context.$implicit,'');
    if (import3.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_AuditFilterComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_AuditFilterComponent,{});
export class View_AuditFilterComponent0 extends import2.AppView<import0.AuditFilterComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  compView_4:import2.AppView<import15.DatePickerRangeComponent>;
  _DatePickerRangeComponent_4_3:import16.Wrapper_DatePickerRangeComponent;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _DefaultValueAccessor_15_3:import17.Wrapper_DefaultValueAccessor;
  _NumberValueAccessor_15_4:import18.Wrapper_NumberValueAccessor;
  _NG_VALUE_ACCESSOR_15_5:any[];
  _NgModel_15_6:import19.Wrapper_NgModel;
  _NgControl_15_7:any;
  _NgControlStatus_15_8:import20.Wrapper_NgControlStatus;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _el_29:any;
  _SelectControlValueAccessor_29_3:import9.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_29_4:any[];
  _NgModel_29_5:import19.Wrapper_NgModel;
  _NgControl_29_6:any;
  _NgControlStatus_29_7:import20.Wrapper_NgControlStatus;
  _text_30:any;
  _el_31:any;
  _NgSelectOption_31_3:import9.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_31_4:import10.Wrapper_NgSelectMultipleOption;
  _text_32:any;
  _text_33:any;
  _anchor_34:any;
  /*private*/ _vc_34:import11.ViewContainer;
  _TemplateRef_34_5:any;
  _NgFor_34_6:import21.Wrapper_NgFor;
  _text_35:any;
  _text_36:any;
  _text_37:any;
  _text_38:any;
  _text_39:any;
  _el_40:any;
  _text_41:any;
  _el_42:any;
  _text_43:any;
  _el_44:any;
  _text_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _el_49:any;
  _DefaultValueAccessor_49_3:import17.Wrapper_DefaultValueAccessor;
  _NumberValueAccessor_49_4:import18.Wrapper_NumberValueAccessor;
  _NG_VALUE_ACCESSOR_49_5:any[];
  _NgModel_49_6:import19.Wrapper_NgModel;
  _NgControl_49_7:any;
  _NgControlStatus_49_8:import20.Wrapper_NgControlStatus;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _text_53:any;
  _el_54:any;
  _text_55:any;
  _el_56:any;
  _text_57:any;
  _el_58:any;
  _text_59:any;
  _text_60:any;
  _el_61:any;
  _text_62:any;
  _el_63:any;
  _DefaultValueAccessor_63_3:import17.Wrapper_DefaultValueAccessor;
  _NumberValueAccessor_63_4:import18.Wrapper_NumberValueAccessor;
  _NG_VALUE_ACCESSOR_63_5:any[];
  _NgModel_63_6:import19.Wrapper_NgModel;
  _NgControl_63_7:any;
  _NgControlStatus_63_8:import20.Wrapper_NgControlStatus;
  _text_64:any;
  _text_65:any;
  _text_66:any;
  _text_67:any;
  _text_68:any;
  _el_69:any;
  _text_70:any;
  _el_71:any;
  _text_72:any;
  _el_73:any;
  _text_74:any;
  _el_75:any;
  _text_76:any;
  _text_77:any;
  _text_78:any;
  _text_79:any;
  _el_80:any;
  _text_81:any;
  _el_82:any;
  _text_83:any;
  _el_84:any;
  _text_85:any;
  _text_86:any;
  _text_87:any;
  _text_88:any;
  _text_89:any;
  _text_90:any;
  _pipe_translate_0:import22.TranslatePipe;
  _pipe_translate_1:import22.TranslatePipe;
  /*private*/ _expr_123:any;
  _pipe_translate_2:import22.TranslatePipe;
  /*private*/ _expr_125:any;
  _pipe_translate_3:import22.TranslatePipe;
  /*private*/ _expr_127:any;
  _pipe_translate_4:import22.TranslatePipe;
  /*private*/ _expr_129:any;
  _pipe_translate_5:import22.TranslatePipe;
  /*private*/ _expr_131:any;
  _pipe_translate_6:import22.TranslatePipe;
  /*private*/ _expr_133:any;
  _pipe_translate_7:import22.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_AuditFilterComponent0,renderType_AuditFilterComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_123 = import1.UNINITIALIZED;
    this._expr_125 = import1.UNINITIALIZED;
    this._expr_127 = import1.UNINITIALIZED;
    this._expr_129 = import1.UNINITIALIZED;
    this._expr_131 = import1.UNINITIALIZED;
    this._expr_133 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','white-container -m-top-lg'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-row'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'sara-datepicker-range',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_4 = new import16.View_DatePickerRangeComponent0(this.viewUtils,this,4,this._el_4);
    this._DatePickerRangeComponent_4_3 = new import16.Wrapper_DatePickerRangeComponent(new import12.ElementRef(this._el_4),this.parentView.injectorGet(import23.CalendarConfig,this.parentIndex));
    this.compView_4.create(this._DatePickerRangeComponent_4_3.context);
    this._text_5 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-lg-3 -md-3 -sm-3'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-input -lg'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -lg'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_12 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','input-container'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n                    ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_13,'input',new import3.InlineArray16(12,'class','input-tag','min','1','name','companyOid','oninput','validity.valid||(value=\'\');','placeholder','Company','type','number'),(null as any));
    this._DefaultValueAccessor_15_3 = new import17.Wrapper_DefaultValueAccessor(this.renderer,new import12.ElementRef(this._el_15));
    this._NumberValueAccessor_15_4 = new import18.Wrapper_NumberValueAccessor(this.renderer,new import12.ElementRef(this._el_15));
    this._NG_VALUE_ACCESSOR_15_5 = [
      this._DefaultValueAccessor_15_3.context,
      this._NumberValueAccessor_15_4.context
    ]
    ;
    this._NgModel_15_6 = new import19.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_15_5);
    this._NgControl_15_7 = this._NgModel_15_6.context;
    this._NgControlStatus_15_8 = new import20.Wrapper_NgControlStatus(this._NgControl_15_7);
    this._text_16 = this.renderer.createText(this._el_13,'\n                ',(null as any));
    this._text_17 = this.renderer.createText(this._el_8,'\n            ',(null as any));
    this._text_18 = this.renderer.createText(this._el_6,'\n        ',(null as any));
    this._text_19 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-lg-3 -md-3 -sm-3'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n            ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_20,'div',new import3.InlineArray2(2,'class','eva-select -md'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n                ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_22,'label',new import3.InlineArray2(2,'class','select-label eva-label-form eva-3-label-form -lg'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'',(null as any));
    this._text_26 = this.renderer.createText(this._el_22,'\n                ',(null as any));
    this._el_27 = import3.createRenderElement(this.renderer,this._el_22,'div',new import3.InlineArray2(2,'class','select-container'),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'\n                    ',(null as any));
    this._el_29 = import3.createRenderElement(this.renderer,this._el_27,'select',new import3.InlineArray4(4,'class','select-tag','name','select-action'),(null as any));
    this._SelectControlValueAccessor_29_3 = new import9.Wrapper_SelectControlValueAccessor(this.renderer,new import12.ElementRef(this._el_29));
    this._NG_VALUE_ACCESSOR_29_4 = [this._SelectControlValueAccessor_29_3.context];
    this._NgModel_29_5 = new import19.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_29_4);
    this._NgControl_29_6 = this._NgModel_29_5.context;
    this._NgControlStatus_29_7 = new import20.Wrapper_NgControlStatus(this._NgControl_29_6);
    this._text_30 = this.renderer.createText(this._el_29,'\n                        ',(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,this._el_29,'option',new import3.InlineArray8(8,'class','select-option','disabled','disabled','selected','selected','value',''),(null as any));
    this._NgSelectOption_31_3 = new import9.Wrapper_NgSelectOption(new import12.ElementRef(this._el_31),this.renderer,this._SelectControlValueAccessor_29_3.context);
    this._NgSelectMultipleOption_31_4 = new import10.Wrapper_NgSelectMultipleOption(new import12.ElementRef(this._el_31),this.renderer,(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'Select an option',(null as any));
    this._text_33 = this.renderer.createText(this._el_29,'\n                        ',(null as any));
    this._anchor_34 = this.renderer.createTemplateAnchor(this._el_29,(null as any));
    this._vc_34 = new import11.ViewContainer(34,29,this,this._anchor_34);
    this._TemplateRef_34_5 = new import24.TemplateRef_(this,34,this._anchor_34);
    this._NgFor_34_6 = new import21.Wrapper_NgFor(this._vc_34.vcRef,this._TemplateRef_34_5,this.parentView.injectorGet(import25.IterableDiffers,this.parentIndex),this.ref);
    this._text_35 = this.renderer.createText(this._el_29,'\n                    ',(null as any));
    this._text_36 = this.renderer.createText(this._el_27,'\n                ',(null as any));
    this._text_37 = this.renderer.createText(this._el_22,'\n            ',(null as any));
    this._text_38 = this.renderer.createText(this._el_20,'\n        ',(null as any));
    this._text_39 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_40 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-lg-3 -md-3 -sm-3'),(null as any));
    this._text_41 = this.renderer.createText(this._el_40,'\n            ',(null as any));
    this._el_42 = import3.createRenderElement(this.renderer,this._el_40,'div',new import3.InlineArray2(2,'class','eva-3-input -lg'),(null as any));
    this._text_43 = this.renderer.createText(this._el_42,'\n                ',(null as any));
    this._el_44 = import3.createRenderElement(this.renderer,this._el_42,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -lg'),(null as any));
    this._text_45 = this.renderer.createText(this._el_44,'',(null as any));
    this._text_46 = this.renderer.createText(this._el_42,'\n                ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_42,'div',new import3.InlineArray2(2,'class','input-container'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'\n                    ',(null as any));
    this._el_49 = import3.createRenderElement(this.renderer,this._el_47,'input',new import3.InlineArray8(8,'class','input-tag','name','page','placeholder','Page','type','number'),(null as any));
    this._DefaultValueAccessor_49_3 = new import17.Wrapper_DefaultValueAccessor(this.renderer,new import12.ElementRef(this._el_49));
    this._NumberValueAccessor_49_4 = new import18.Wrapper_NumberValueAccessor(this.renderer,new import12.ElementRef(this._el_49));
    this._NG_VALUE_ACCESSOR_49_5 = [
      this._DefaultValueAccessor_49_3.context,
      this._NumberValueAccessor_49_4.context
    ]
    ;
    this._NgModel_49_6 = new import19.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_49_5);
    this._NgControl_49_7 = this._NgModel_49_6.context;
    this._NgControlStatus_49_8 = new import20.Wrapper_NgControlStatus(this._NgControl_49_7);
    this._text_50 = this.renderer.createText(this._el_47,'\n                ',(null as any));
    this._text_51 = this.renderer.createText(this._el_42,'\n            ',(null as any));
    this._text_52 = this.renderer.createText(this._el_40,'\n        ',(null as any));
    this._text_53 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_54 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','-lg-3 -md-3 -sm-3'),(null as any));
    this._text_55 = this.renderer.createText(this._el_54,'\n            ',(null as any));
    this._el_56 = import3.createRenderElement(this.renderer,this._el_54,'div',new import3.InlineArray2(2,'class','eva-3-input -lg'),(null as any));
    this._text_57 = this.renderer.createText(this._el_56,'\n                ',(null as any));
    this._el_58 = import3.createRenderElement(this.renderer,this._el_56,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -lg'),(null as any));
    this._text_59 = this.renderer.createText(this._el_58,'',(null as any));
    this._text_60 = this.renderer.createText(this._el_56,'\n                ',(null as any));
    this._el_61 = import3.createRenderElement(this.renderer,this._el_56,'div',new import3.InlineArray2(2,'class','input-container'),(null as any));
    this._text_62 = this.renderer.createText(this._el_61,'\n                    ',(null as any));
    this._el_63 = import3.createRenderElement(this.renderer,this._el_61,'input',new import3.InlineArray8(8,'class','input-tag','name','offset','placeholder','Offset','type','number'),(null as any));
    this._DefaultValueAccessor_63_3 = new import17.Wrapper_DefaultValueAccessor(this.renderer,new import12.ElementRef(this._el_63));
    this._NumberValueAccessor_63_4 = new import18.Wrapper_NumberValueAccessor(this.renderer,new import12.ElementRef(this._el_63));
    this._NG_VALUE_ACCESSOR_63_5 = [
      this._DefaultValueAccessor_63_3.context,
      this._NumberValueAccessor_63_4.context
    ]
    ;
    this._NgModel_63_6 = new import19.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_63_5);
    this._NgControl_63_7 = this._NgModel_63_6.context;
    this._NgControlStatus_63_8 = new import20.Wrapper_NgControlStatus(this._NgControl_63_7);
    this._text_64 = this.renderer.createText(this._el_61,'\n                ',(null as any));
    this._text_65 = this.renderer.createText(this._el_56,'\n            ',(null as any));
    this._text_66 = this.renderer.createText(this._el_54,'\n        ',(null as any));
    this._text_67 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_68 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_69 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-row reset-styles'),(null as any));
    this._text_70 = this.renderer.createText(this._el_69,'\n        ',(null as any));
    this._el_71 = import3.createRenderElement(this.renderer,this._el_69,'div',new import3.InlineArray2(2,'class','-lg-1 -md-1 -sm-1'),(null as any));
    this._text_72 = this.renderer.createText(this._el_71,'\n            ',(null as any));
    this._el_73 = import3.createRenderElement(this.renderer,this._el_71,'a',new import3.InlineArray2(2,'class','eva-btn -md -secondary -loader ng-isolate-scope'),(null as any));
    this._text_74 = this.renderer.createText(this._el_73,'\n                ',(null as any));
    this._el_75 = import3.createRenderElement(this.renderer,this._el_73,'em',new import3.InlineArray2(2,'class','btn-text ng-binding'),(null as any));
    this._text_76 = this.renderer.createText(this._el_75,'',(null as any));
    this._text_77 = this.renderer.createText(this._el_73,'\n            ',(null as any));
    this._text_78 = this.renderer.createText(this._el_71,'\n        ',(null as any));
    this._text_79 = this.renderer.createText(this._el_69,'\n        ',(null as any));
    this._el_80 = import3.createRenderElement(this.renderer,this._el_69,'div',new import3.InlineArray2(2,'class','-lg-1 -md-1 -sm-1'),(null as any));
    this._text_81 = this.renderer.createText(this._el_80,'\n            ',(null as any));
    this._el_82 = import3.createRenderElement(this.renderer,this._el_80,'a',new import3.InlineArray2(2,'class','eva-btn -md -tertiary -loader ng-isolate-scope'),(null as any));
    this._text_83 = this.renderer.createText(this._el_82,'\n                ',(null as any));
    this._el_84 = import3.createRenderElement(this.renderer,this._el_82,'em',new import3.InlineArray2(2,'class','btn-text ng-binding'),(null as any));
    this._text_85 = this.renderer.createText(this._el_84,'',(null as any));
    this._text_86 = this.renderer.createText(this._el_82,'\n            ',(null as any));
    this._text_87 = this.renderer.createText(this._el_80,'\n        ',(null as any));
    this._text_88 = this.renderer.createText(this._el_69,'\n    ',(null as any));
    this._text_89 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_90 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._pipe_translate_0 = new import22.TranslatePipe(this.parentView.injectorGet(import26.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import22.TranslatePipe(this.parentView.injectorGet(import26.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import22.TranslatePipe(this.parentView.injectorGet(import26.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_15,new import3.InlineArray8(8,'ngModelChange',(null as any),'input',(null as any),'blur',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_15));
    this._NgModel_15_6.subscribe(this,this.eventHandler(this.handleEvent_15),true);
    this._pipe_translate_3 = new import22.TranslatePipe(this.parentView.injectorGet(import26.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_29,new import3.InlineArray8(6,'ngModelChange',(null as any),'change',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_29));
    this._NgModel_29_5.subscribe(this,this.eventHandler(this.handleEvent_29),true);
    this._pipe_translate_4 = new import22.TranslatePipe(this.parentView.injectorGet(import26.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_49,new import3.InlineArray8(8,'ngModelChange',(null as any),'input',(null as any),'blur',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_49));
    this._NgModel_49_6.subscribe(this,this.eventHandler(this.handleEvent_49),true);
    this._pipe_translate_5 = new import22.TranslatePipe(this.parentView.injectorGet(import26.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_63,new import3.InlineArray8(8,'ngModelChange',(null as any),'input',(null as any),'blur',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_63));
    this._NgModel_63_6.subscribe(this,this.eventHandler(this.handleEvent_63),true);
    var disposable_4:Function = import3.subscribeToRenderElement(this,this._el_73,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_73));
    this._pipe_translate_6 = new import22.TranslatePipe(this.parentView.injectorGet(import26.TranslateService,this.parentIndex),this.ref);
    var disposable_5:Function = import3.subscribeToRenderElement(this,this._el_82,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_82));
    this._pipe_translate_7 = new import22.TranslatePipe(this.parentView.injectorGet(import26.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._el_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._text_33,
      this._anchor_34,
      this._text_35,
      this._text_36,
      this._text_37,
      this._text_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._el_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._text_53,
      this._el_54,
      this._text_55,
      this._el_56,
      this._text_57,
      this._el_58,
      this._text_59,
      this._text_60,
      this._el_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._text_65,
      this._text_66,
      this._text_67,
      this._text_68,
      this._el_69,
      this._text_70,
      this._el_71,
      this._text_72,
      this._el_73,
      this._text_74,
      this._el_75,
      this._text_76,
      this._text_77,
      this._text_78,
      this._text_79,
      this._el_80,
      this._text_81,
      this._el_82,
      this._text_83,
      this._el_84,
      this._text_85,
      this._text_86,
      this._text_87,
      this._text_88,
      this._text_89,
      this._text_90
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import15.DatePickerRangeComponent) && (4 === requestNodeIndex))) { return this._DatePickerRangeComponent_4_3.context; }
    if (((token === import27.DefaultValueAccessor) && (15 === requestNodeIndex))) { return this._DefaultValueAccessor_15_3.context; }
    if (((token === import28.NumberValueAccessor) && (15 === requestNodeIndex))) { return this._NumberValueAccessor_15_4.context; }
    if (((token === import29.NG_VALUE_ACCESSOR) && (15 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_15_5; }
    if (((token === import30.NgModel) && (15 === requestNodeIndex))) { return this._NgModel_15_6.context; }
    if (((token === import31.NgControl) && (15 === requestNodeIndex))) { return this._NgControl_15_7; }
    if (((token === import32.NgControlStatus) && (15 === requestNodeIndex))) { return this._NgControlStatus_15_8.context; }
    if (((token === import13.NgSelectOption) && ((31 <= requestNodeIndex) && (requestNodeIndex <= 32)))) { return this._NgSelectOption_31_3.context; }
    if (((token === import14.NgSelectMultipleOption) && ((31 <= requestNodeIndex) && (requestNodeIndex <= 32)))) { return this._NgSelectMultipleOption_31_4.context; }
    if (((token === import24.TemplateRef) && (34 === requestNodeIndex))) { return this._TemplateRef_34_5; }
    if (((token === import33.NgFor) && (34 === requestNodeIndex))) { return this._NgFor_34_6.context; }
    if (((token === import13.SelectControlValueAccessor) && ((29 <= requestNodeIndex) && (requestNodeIndex <= 35)))) { return this._SelectControlValueAccessor_29_3.context; }
    if (((token === import29.NG_VALUE_ACCESSOR) && ((29 <= requestNodeIndex) && (requestNodeIndex <= 35)))) { return this._NG_VALUE_ACCESSOR_29_4; }
    if (((token === import30.NgModel) && ((29 <= requestNodeIndex) && (requestNodeIndex <= 35)))) { return this._NgModel_29_5.context; }
    if (((token === import31.NgControl) && ((29 <= requestNodeIndex) && (requestNodeIndex <= 35)))) { return this._NgControl_29_6; }
    if (((token === import32.NgControlStatus) && ((29 <= requestNodeIndex) && (requestNodeIndex <= 35)))) { return this._NgControlStatus_29_7.context; }
    if (((token === import27.DefaultValueAccessor) && (49 === requestNodeIndex))) { return this._DefaultValueAccessor_49_3.context; }
    if (((token === import28.NumberValueAccessor) && (49 === requestNodeIndex))) { return this._NumberValueAccessor_49_4.context; }
    if (((token === import29.NG_VALUE_ACCESSOR) && (49 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_49_5; }
    if (((token === import30.NgModel) && (49 === requestNodeIndex))) { return this._NgModel_49_6.context; }
    if (((token === import31.NgControl) && (49 === requestNodeIndex))) { return this._NgControl_49_7; }
    if (((token === import32.NgControlStatus) && (49 === requestNodeIndex))) { return this._NgControlStatus_49_8.context; }
    if (((token === import27.DefaultValueAccessor) && (63 === requestNodeIndex))) { return this._DefaultValueAccessor_63_3.context; }
    if (((token === import28.NumberValueAccessor) && (63 === requestNodeIndex))) { return this._NumberValueAccessor_63_4.context; }
    if (((token === import29.NG_VALUE_ACCESSOR) && (63 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_63_5; }
    if (((token === import30.NgModel) && (63 === requestNodeIndex))) { return this._NgModel_63_6.context; }
    if (((token === import31.NgControl) && (63 === requestNodeIndex))) { return this._NgControl_63_7; }
    if (((token === import32.NgControlStatus) && (63 === requestNodeIndex))) { return this._NgControlStatus_63_8.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_4_0_0:any = false;
    this._DatePickerRangeComponent_4_3.check_disableDates(currVal_4_0_0,throwOnChange,false);
    const currVal_4_0_1:any = this.context.model.filterPeriod;
    this._DatePickerRangeComponent_4_3.check_period(currVal_4_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_4_0_2:any = valUnwrapper.unwrap(this._pipe_translate_0.transform('common.FROM'));
    this._DatePickerRangeComponent_4_3.check_fromPlaceholder(currVal_4_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    valUnwrapper.reset();
    const currVal_4_0_3:any = valUnwrapper.unwrap(this._pipe_translate_1.transform('common.TO'));
    this._DatePickerRangeComponent_4_3.check_toPlaceholder(currVal_4_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    this._DatePickerRangeComponent_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    this._DefaultValueAccessor_15_3.ngDoCheck(this,this._el_15,throwOnChange);
    this._NumberValueAccessor_15_4.ngDoCheck(this,this._el_15,throwOnChange);
    const currVal_15_2_0:any = 'companyOid';
    this._NgModel_15_6.check_name(currVal_15_2_0,throwOnChange,false);
    const currVal_15_2_1:any = this.context.model.companyOid;
    this._NgModel_15_6.check_model(currVal_15_2_1,throwOnChange,false);
    this._NgModel_15_6.ngDoCheck(this,this._el_15,throwOnChange);
    this._NgControlStatus_15_8.ngDoCheck(this,this._el_15,throwOnChange);
    this._SelectControlValueAccessor_29_3.ngDoCheck(this,this._el_29,throwOnChange);
    const currVal_29_1_0:any = 'select-action';
    this._NgModel_29_5.check_name(currVal_29_1_0,throwOnChange,false);
    const currVal_29_1_1:any = this.context.model.action;
    this._NgModel_29_5.check_model(currVal_29_1_1,throwOnChange,false);
    this._NgModel_29_5.ngDoCheck(this,this._el_29,throwOnChange);
    this._NgControlStatus_29_7.ngDoCheck(this,this._el_29,throwOnChange);
    const currVal_31_0_0:any = '';
    this._NgSelectOption_31_3.check_value(currVal_31_0_0,throwOnChange,false);
    this._NgSelectOption_31_3.ngDoCheck(this,this._el_31,throwOnChange);
    const currVal_31_1_0:any = '';
    this._NgSelectMultipleOption_31_4.check_value(currVal_31_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_31_4.ngDoCheck(this,this._el_31,throwOnChange);
    const currVal_34_0_0:any = this.context.actions;
    this._NgFor_34_6.check_ngForOf(currVal_34_0_0,throwOnChange,false);
    this._NgFor_34_6.ngDoCheck(this,this._anchor_34,throwOnChange);
    this._DefaultValueAccessor_49_3.ngDoCheck(this,this._el_49,throwOnChange);
    this._NumberValueAccessor_49_4.ngDoCheck(this,this._el_49,throwOnChange);
    const currVal_49_2_0:any = 'page';
    this._NgModel_49_6.check_name(currVal_49_2_0,throwOnChange,false);
    const currVal_49_2_1:any = this.context.model.page;
    this._NgModel_49_6.check_model(currVal_49_2_1,throwOnChange,false);
    this._NgModel_49_6.ngDoCheck(this,this._el_49,throwOnChange);
    this._NgControlStatus_49_8.ngDoCheck(this,this._el_49,throwOnChange);
    this._DefaultValueAccessor_63_3.ngDoCheck(this,this._el_63,throwOnChange);
    this._NumberValueAccessor_63_4.ngDoCheck(this,this._el_63,throwOnChange);
    const currVal_63_2_0:any = 'offset';
    this._NgModel_63_6.check_name(currVal_63_2_0,throwOnChange,false);
    const currVal_63_2_1:any = this.context.model.offset;
    this._NgModel_63_6.check_model(currVal_63_2_1,throwOnChange,false);
    this._NgModel_63_6.ngDoCheck(this,this._el_63,throwOnChange);
    this._NgControlStatus_63_8.ngDoCheck(this,this._el_63,throwOnChange);
    this._vc_34.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_123:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('audit.filters.company')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_123,currVal_123))) {
      this.renderer.setText(this._text_11,currVal_123);
      this._expr_123 = currVal_123;
    }
    this._NgControlStatus_15_8.checkHost(this,this,this._el_15,throwOnChange);
    valUnwrapper.reset();
    const currVal_125:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('audit.filters.action')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_125,currVal_125))) {
      this.renderer.setText(this._text_25,currVal_125);
      this._expr_125 = currVal_125;
    }
    this._NgControlStatus_29_7.checkHost(this,this,this._el_29,throwOnChange);
    valUnwrapper.reset();
    const currVal_127:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('audit.filters.page')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_127,currVal_127))) {
      this.renderer.setText(this._text_45,currVal_127);
      this._expr_127 = currVal_127;
    }
    this._NgControlStatus_49_8.checkHost(this,this,this._el_49,throwOnChange);
    valUnwrapper.reset();
    const currVal_129:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('audit.filters.offset')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_129,currVal_129))) {
      this.renderer.setText(this._text_59,currVal_129);
      this._expr_129 = currVal_129;
    }
    this._NgControlStatus_63_8.checkHost(this,this,this._el_63,throwOnChange);
    valUnwrapper.reset();
    const currVal_131:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('audit.filters.filter')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_131,currVal_131))) {
      this.renderer.setText(this._text_76,currVal_131);
      this._expr_131 = currVal_131;
    }
    valUnwrapper.reset();
    const currVal_133:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('audit.filters.download')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_133,currVal_133))) {
      this.renderer.setText(this._text_85,currVal_133);
      this._expr_133 = currVal_133;
    }
    this.compView_4.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_34.destroyNestedViews();
    this.compView_4.destroy();
    this._DatePickerRangeComponent_4_3.ngOnDestroy();
    this._NgModel_15_6.ngOnDestroy();
    this._NgSelectOption_31_3.ngOnDestroy();
    this._NgSelectMultipleOption_31_4.ngOnDestroy();
    this._NgModel_29_5.ngOnDestroy();
    this._NgModel_49_6.ngOnDestroy();
    this._NgModel_63_6.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 34)) { return new View_AuditFilterComponent1(this.viewUtils,this,34,this._anchor_34,this._vc_34); }
    return (null as any);
  }
  handleEvent_15(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_15_3.handleEvent(eventName,$event) && result);
    result = (this._NumberValueAccessor_15_4.handleEvent(eventName,$event) && result);
    if ((eventName == 'ngModelChange')) {
      const pd_sub_0:any = ((<any>(this.context.model.companyOid = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_29(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._SelectControlValueAccessor_29_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'ngModelChange')) {
      const pd_sub_0:any = ((<any>(this.context.model.action = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_49(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_49_3.handleEvent(eventName,$event) && result);
    result = (this._NumberValueAccessor_49_4.handleEvent(eventName,$event) && result);
    if ((eventName == 'ngModelChange')) {
      const pd_sub_0:any = ((<any>(this.context.model.page = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_63(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_63_3.handleEvent(eventName,$event) && result);
    result = (this._NumberValueAccessor_63_4.handleEvent(eventName,$event) && result);
    if ((eventName == 'ngModelChange')) {
      const pd_sub_0:any = ((<any>(this.context.model.offset = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_73(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.filterAudit()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_82(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.exportAudit()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/audit/audit-filter/audit-filter.component.ngfactory.ts